import { PersonType, Proving, ProvingType } from 'gql.generated'

export function validate(proving: Proving) {
  const statErrors = []
  if (
    proving.vehicles &&
    proving.vehicles.length === 0 &&
    proving.type !== ProvingType.BusinessTrip
  ) {
    statErrors.push('Bitte geben Sie mindestens ein Fahrzeug an.')
  }
  if (proving.vehicles && proving.vehicles.length !== 0) {
    for (const provVehicle of proving.vehicles) {
      if (!provVehicle.orderId) {
        statErrors.push(
          'Bitte geben Sie bei jedem Fahrzeug eine Auftragsnummer an.'
        )
        break
      }
    }
  }
  if (proving.participants) {
    if (proving.participants.length === 0) {
      statErrors.push('Bitte geben Sie mindestens einen Teilnehmer an.')
    } else {
      let countUsers = 0
      let countMissingIds = 0
      proving.participants.forEach((participant) => {
        if (participant.person && participant.person.type === PersonType.User) {
          countUsers++
        }
        // if any of Unterkunft, Miertwager or Flug are created than Auftragsnummer must be filled for every person.
        if (!participant.orderId) {
          countMissingIds++
        }
      })
      if (countUsers === 0 && !proving.dvtWvtCheckDisabled) {
        statErrors.push(
          'Bitte beachten Sie, dass während des gesamten Erprobungszeitraums mindestens ein PAG-Teilnehmer anwesend sein muss.'
        )
      }
      if (countMissingIds !== 0) {
        statErrors.push(
          'Bitte geben Sie bei allen Teilnehmern eine Auftragsnummer für die Kostenabrechnung an.'
        )
      }
    }
  }
  if (
    !(
      proving.title &&
      proving.description &&
      proving.dateFrom &&
      proving.dateTo &&
      proving.department &&
      proving.orderIdDistribution &&
      proving.orderIdDistribution.length !== 0 &&
      (proving.supportNeeds?.evd ||
        proving.supportNeeds?.ewg ||
        proving.supportNeeds?.ewi ||
        proving.supportNeeds?.hv ||
        proving.supportNeeds?.noSupport)
    )
  ) {
    statErrors.push(
      'Alle Pflichtfelder müssen befüllt sein. Bitte überprüfen Sie, dass das Formular gespeichert wurde.'
    )
  }
  if (!proving.headOfProvingCheckDisabled) {
    validateHeadOfProving(proving, statErrors)
  }

  return statErrors
}

function validateHeadOfProving(proving: Proving, statErrors: string[]) {
  const latestDate: Date = new Date(proving.dateTo)
  const lowestDate: Date = new Date(proving.dateFrom)
  const diffTime = Math.abs(latestDate.getTime() - lowestDate.getTime())
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24) + 1)
  const headOfProvings = new Array<number>(diffDays).fill(0)
  const dates: string[] = []

  let index = 0
  for (
    lowestDate;
    lowestDate <= latestDate;
    lowestDate.setDate(lowestDate.getDate() + 1)
  ) {
    const dateOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }
    dates.push(lowestDate.toLocaleDateString('de-DE', dateOptions))
    if (proving && proving.participants) {
      for (
        let participant = 0;
        participant < proving.participants.length;
        participant++
      ) {
        if (
          new Date(
            proving!.participants![participant].headOfProving!.dateFrom
          ) <= lowestDate &&
          new Date(proving!.participants![participant].headOfProving!.dateTo) >=
            lowestDate
        ) {
          headOfProvings[index] += 1
        }
      }
    }
    index++
  }

  let dateColumn = ''
  headOfProvings.forEach((hop, i) =>
    hop === 0 && dates[i] ? (dateColumn += dates[i] + '\n') : ''
  )

  if (dateColumn !== '') {
    statErrors.push(
      'Bitte definieren Sie an folgenden Tagen einen Erprobungsleiter:\n' +
        dateColumn
    )
  }
}
